import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createSelectors } from '@/pages/ai-consultation/store/useAIDiagnoseStore';

export interface TBodyPainAdjustStore {
  showType: 'all' | 'shoulder' | 'waist';
}

const initialStoreValue = {
  showType: 'all' as TBodyPainAdjustStore['showType'],
};

export const useBodyPainAdjustStore = createSelectors(
  create(
    devtools<TBodyPainAdjustStore>(() => initialStoreValue, {
      name: 'body-pain-adjust',
    })
  )
);

export const setBodyPainShowType = (payload: TBodyPainAdjustStore['showType']) =>
  useBodyPainAdjustStore.setState(() => ({ showType: payload }));

export const resetBodyPainAdjustStore = () => {
  useBodyPainAdjustStore.setState(initialStoreValue);
};
